(function ($) {
  'use strict';

  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.rich-text.order-details .help').each(function () {
      var $this = $(this),
        $content = $('.help-content', $this.parent()),
        $overlay = $('.help-content-overlay', $this.parent()),
        $contentButton = $('.help-content-button', $content);
      $.merge($this, $contentButton).click(function () {
        if (!$overlay.length) {
          $overlay = $('<div class="help-content-overlay"></div>');
          $content.before($overlay);
        }
        if (!$content.is(':visible')) {
          $overlay.show();
          $content.show();
          TweenMax.fromTo($content, 0.3, {
            alpha: 0
          }, {
            alpha: 1,
            ease: Power2.easeIn
          });
        } else {
          TweenMax.fromTo($content, 0.3, {
            alpha: 1
          }, {
            alpha: 0,
            ease: Power2.easeIn,
            onComplete: function onComplete() {
              $content.hide();
              $overlay.hide();
            }
          });
        }
      });
      var isFirst = true;
      $('.component.top-margin').each(function () {
        if (!isFirst) $(this).removeClass('top-margin');
        if (isFirst) {
          isFirst = false;
        }
      });
    });

    // OD-4817
    // The re-structure of the markup is done very hardcoded and
    // here instead of in the markup, because Oticon US use the markup as it is.
    if ($('.order-details').length) {
      var $backToList = $('.rich-text.b2b-entry-details').first();
      var $heading = $backToList.next();
      var $notice = $backToList.prev();
      var noticeText = $notice.text();
      var $orderNumber = $('h2', $heading);
      $orderNumber.wrap('<div class="heading-wrapper"></div>');
      var $headingWrapper = $('.heading-wrapper', $heading);
      $notice.remove();
      $backToList.addClass('back-to-list');
      $headingWrapper.append("<p>".concat(noticeText, "</p>"));
      $orderNumber.css('float', 'none');
    }
  });
})(jQuery);